const key = "lang";
const defaultLanguage = "en";

const getLanguage = () => {
    if (localStorage.getItem(key)) {
        return localStorage.getItem(key);
    } else {
        return setDefaultLanguage();
    }
};

const setLanguage = (lang) => {
    localStorage.setItem(key, lang);
    window.location.reload();
    return lang;
};

const setDefaultLanguage = () => {
    if (localStorage.getItem(key) !== defaultLanguage)
        setLanguage(defaultLanguage);
    return defaultLanguage;
};

export { defaultLanguage, getLanguage, setLanguage, setDefaultLanguage };


// WEBPACK FOOTER //
// ./src/Util/language.ts